// @flow
import ShippingStatus from './ShippingStatus';

export default ShippingStatus;
